export interface SEOTemplate {
  title: {
    es: string;
    en: string;
  };
  description: {
    es: string;
    en: string;
  };
  keywords: {
    es: string[];
    en: string[];
  };
  url: {
    es: string;
    en: string;
  };
  h1: {
    es: string;
    en: string;
  };
  structuredData?: {
    type: string;
    data: any;
  };
}

export const seoTemplates: Record<string, SEOTemplate> = {
  home: {
    title: {
      es: "Consultor SEO en Houston | SEO Técnico, Local y Bilingüe - Luis ROC",
      en: "Houston SEO Consultant | Technical, Local & Bilingual SEO - Luis ROC"
    },
    description: {
      es: "Luis ROC, consultor SEO en Houston para empresas B2B y el mercado hispano de EE. UU. SEO técnico, local e internacional. Solicita un diagnóstico estratégico.",
      en: "Luis ROC, Houston SEO consultant for B2B companies and the US Hispanic market. Technical, local and international SEO. Request a strategic review."
    },
    keywords: {
      es: ["consultor SEO Houston", "marketing digital empresas hispanas", "SEO español Houston", "Google Ads Houston", "consultor marketing digital Latino", "posicionamiento web Houston", "SEO para negocios hispanos", "marketing digital Texas"],
      en: ["Houston SEO consultant", "Hispanic business marketing", "bilingual SEO Houston", "Google Ads consultant", "Latino digital marketing", "Spanish SEO Houston", "Hispanic business SEO", "Texas digital marketing"]
    },
    url: {
      es: "https://luisroc.com",
      en: "https://luisroc.com/en"
    },
    h1: {
      es: "Consultor SEO en Houston para empresas B2B y mercado hispano",
      en: "Houston SEO Consultant for B2B and Hispanic-Market Companies"
    }
  },
  
  about: {
    title: {
      es: "Sobre Luis ROC | Consultor SEO y Search Growth en Houston",
      en: "About Luis ROC | SEO and Search Growth Consultant in Houston"
    },
    description: {
      es: "Conoce a Luis ROC, consultor SEO en Houston especializado en empresas B2B e hispanas. CEO de ROC Worldwide Agency: SEO técnico, Search Growth y Google Ads en EN/ES.",
      en: "Meet Luis ROC, Houston SEO consultant focused on B2B and Hispanic-market companies. CEO of ROC Worldwide Agency: technical SEO, Search Growth and Google Ads in EN/ES."
    },
    keywords: {
      es: ["Luis ROC consultor SEO", "experiencia SEO Houston", "consultor marketing digital Houston", "CEO ROC Worldwide Agency", "experto SEO Latino", "consultor bilingüe Houston"],
      en: ["Luis ROC SEO consultant", "Houston SEO experience", "digital marketing consultant Houston", "CEO ROC Worldwide Agency", "Latino SEO expert", "bilingual consultant Houston"]
    },
    url: {
      es: "https://luisroc.com/sobre-luis-roc",
      en: "https://luisroc.com/about-luis-roc"
    },
    h1: {
      es: "Luis ROC - Consultor en SEO, Search Growth y Marketing Digital",
      en: "Luis ROC - Consultant in SEO, Search Growth and Digital Marketing"
    }
  },
  
  services: {
    title: {
      es: "Servicios SEO y Marketing Digital Houston | Especializado Empresas Hispanas - Luis ROC",
      en: "SEO & Digital Marketing Services Houston | Hispanic Business Specialist - Luis ROC"
    },
    description: {
      es: "Servicios completos de SEO, Google Ads y marketing digital en Houston para empresas hispanas. Diagnóstico estratégico inicial y estrategias adaptadas a cada negocio.",
      en: "SEO, Google Ads and digital marketing services in Houston for Hispanic businesses. Free 30-minute initial consultation, senior-led strategy and transparent measurement."
    },
    keywords: {
      es: ["servicios SEO Houston", "Google Ads Houston", "marketing digital empresas hispanas", "consultoría SEO bilingüe", "posicionamiento web Houston", "SEM Houston", "optimización web Houston"],
      en: ["SEO services Houston", "Google Ads Houston", "Hispanic business digital marketing", "bilingual SEO consulting", "web positioning Houston", "SEM Houston", "web optimization Houston"]
    },
    url: {
      es: "https://luisroc.com/servicios",
      en: "https://luisroc.com/services"
    },
    h1: {
      es: "Servicios de SEO y Marketing Digital para Empresas Hispanas en Houston",
      en: "SEO and Digital Marketing Services for Hispanic Businesses in Houston"
    }
  },
  
  contact: {
    title: {
      es: "Contacto | Luis ROC, Consultor SEO senior en Houston",
      en: "Contact | Luis ROC, Senior SEO Consultant in Houston"
    },
    description: {
      es: "Escríbele directamente a Luis ROC sobre tu proyecto de SEO técnico, internacional, bilingüe o ecommerce. Cuéntale objetivo, sitio web y contexto del negocio.",
      en: "Reach Luis ROC directly about a technical, international, bilingual or ecommerce SEO project. Share your goal, website and business context to get a useful reply."
    },
    keywords: {
      es: ["contacto consultor SEO", "contacto Luis ROC", "consultor SEO Houston contacto", "hablar con consultor SEO B2B"],
      en: ["SEO consultant contact", "contact Luis ROC", "Houston SEO consultant contact", "talk to a B2B SEO consultant"]
    },
    url: {
      es: "https://luisroc.com/contacto",
      en: "https://luisroc.com/en/contact"
    },
    h1: {
      es: "Contacta a Luis ROC",
      en: "Contact Luis ROC"
    }
  },
  
  blog: {
    title: {
      es: "Blog SEO y Marketing Digital | Consejos Empresas Hispanas Houston - Luis ROC",
      en: "SEO & Digital Marketing Blog | Hispanic Business Tips Houston - Luis ROC"
    },
    description: {
      es: "Blog especializado en SEO y marketing digital para empresas hispanas. Guías, consejos, estrategias y casos de éxito por Luis ROC, consultor SEO en Houston.",
      en: "Specialized blog on SEO and digital marketing for Hispanic businesses. Guides, tips, strategies and success stories by Luis ROC, SEO consultant in Houston."
    },
    keywords: {
      es: ["blog SEO Houston", "marketing digital empresas hispanas", "consejos SEO español", "estrategias marketing digital", "casos éxito SEO Houston", "guías SEO Latino"],
      en: ["Houston SEO blog", "Hispanic business digital marketing", "Spanish SEO tips", "digital marketing strategies", "Houston SEO success stories", "Latino SEO guides"]
    },
    url: {
      es: "https://luisroc.com/blog",
      en: "https://luisroc.com/blog"
    },
    h1: {
      es: "Blog de SEO y Marketing Digital para Empresas Hispanas",
      en: "SEO and Digital Marketing Blog for Hispanic Businesses"
    }
  },
  
  // Páginas de servicios específicos
  seoAudit: {
    title: {
      es: "Reunión inicial gratuita de 30 minutos en Houston - Luis ROC",
      en: "Free 30-minute initial consultation in Houston - Luis ROC"
    },
    description: {
      es: "Reunión inicial gratuita de 30 minutos para empresas en Houston: revisamos qué necesita tu empresa y definimos posibles siguientes pasos.",
      en: "Free 30-minute initial consultation for companies in Houston: we review what your company needs and define possible next steps."
    },
    keywords: {
      es: ["reunión inicial gratuita 30 minutos Houston", "consultoría SEO empresas hispanas", "consultor SEO Houston"],
      en: ["free 30-minute initial consultation Houston", "Hispanic business SEO consulting", "Houston SEO consultant"]
    },
    url: {
      es: "https://luisroc.com/servicios/seo-diagnostico",
      en: "https://luisroc.com/services/seo-audit"
    },
    h1: {
      es: "Reunión inicial gratuita de 30 minutos para tu empresa en Houston",
      en: "Free 30-minute initial consultation for your company in Houston"
    }
  },
  
  googleAds: {
    title: {
      es: "Google Ads Houston | Publicidad PPC Empresas Hispanas - Luis ROC",
      en: "Google Ads Houston | PPC Advertising Hispanic Businesses - Luis ROC"
    },
    description: {
      es: "Experto Google Ads en Houston para empresas hispanas. Campañas PPC optimizadas y medición de conversiones. Consulta inicial disponible.",
      en: "Google Ads consultant in Houston for Hispanic businesses. Bilingual PPC campaigns, wasted-spend control and conversion tracking. Free 30-minute initial consultation."
    },
    keywords: {
      es: ["Google Ads Houston", "publicidad PPC empresas hispanas", "campañas Google bilingües", "consultor Google Ads Houston", "PPC marketing digital Houston"],
      en: ["Google Ads Houston", "Hispanic business PPC advertising", "bilingual Google campaigns", "Google Ads consultant Houston", "PPC digital marketing Houston"]
    },
    url: {
      es: "https://luisroc.com/servicios/google-ads",
      en: "https://luisroc.com/services/google-ads"
    },
    h1: {
      es: "Google Ads para Empresas Hispanas en Houston",
      en: "Google Ads for Hispanic Businesses in Houston"
    }
  },
  
  llmPositioning: {
    title: {
      es: "Posicionamiento IA y ChatGPT | SEO Inteligencia Artificial Houston - Luis ROC",
      en: "AI & ChatGPT Positioning | Artificial Intelligence SEO Houston - Luis ROC"
    },
    description: {
      es: "Posicionamiento en motores de IA como ChatGPT, Gemini, Claude. Optimización para búsquedas conversacionales y respuestas AI. Estrategia SEO del futuro para empresas hispanas.",
      en: "Positioning in AI engines like ChatGPT, Gemini, Claude. Optimization for conversational searches and AI responses. Future SEO strategy for Hispanic businesses."
    },
    keywords: {
      es: ["posicionamiento ChatGPT", "SEO inteligencia artificial", "optimización IA", "búsquedas conversacionales", "SEO futuro empresas hispanas", "ChatGPT optimization"],
      en: ["ChatGPT positioning", "artificial intelligence SEO", "AI optimization", "conversational search", "future SEO Hispanic businesses", "AI search optimization"]
    },
    url: {
      es: "https://luisroc.com/servicios/posicionamiento-ia",
      en: "https://luisroc.com/services/ai-positioning"
    },
    h1: {
      es: "Posicionamiento en Motores de Inteligencia Artificial",
      en: "Positioning in Artificial Intelligence Engines"
    }
  },
  
  // Herramientas SEO
  seoTools: {
    title: {
      es: "Herramientas SEO Gratuitas Online | Análisis Web Houston - Luis ROC",
      en: "Free Online SEO Tools | Web Analysis Houston - Luis ROC"
    },
    description: {
      es: "Herramientas SEO gratuitas: analizador de palabras clave, verificador de densidad, generador meta tags, contador de palabras y más. Optimiza tu web gratis.",
      en: "Free SEO tools: keyword analyzer, density checker, meta tags generator, word counter and more. Optimize your website for free."
    },
    keywords: {
      es: ["herramientas SEO gratuitas", "analizador SEO online", "herramientas marketing digital", "SEO tools español", "optimización web gratuita"],
      en: ["free SEO tools", "online SEO analyzer", "digital marketing tools", "Spanish SEO tools", "free web optimization"]
    },
    url: {
      es: "https://luisroc.com/herramientas-seo",
      en: "https://luisroc.com/seo-tools"
    },
    h1: {
      es: "Herramientas SEO Gratuitas para Optimizar tu Web",
      en: "Free SEO Tools to Optimize Your Website"
    }
  },
  
  amazonConsulting: {
    title: {
      es: "Consultoría Amazon Houston | Optimización Marketplaces - Luis ROC",
      en: "Amazon Consulting Houston | Marketplace Optimization - Luis ROC"
    },
    description: {
      es: "Consultoría especializada en Amazon, Walmart, Etsy y eBay para empresas hispanas. Optimización de listings, arquitectura de catálogo y estrategia de descubrimiento en marketplaces.",
      en: "Specialized consulting for Amazon, Walmart, Etsy and eBay for Hispanic businesses. Listing optimization, catalog architecture and marketplace discovery strategy."
    },
    keywords: {
      es: ["consultoría Amazon Houston", "optimización Amazon", "Amazon para empresas hispanas", "marketplaces consulting", "vender en Amazon", "Amazon SEO Houston", "consultor Amazon Texas"],
      en: ["Amazon consulting Houston", "Amazon optimization", "Amazon for Hispanic businesses", "marketplaces consulting", "sell on Amazon", "Amazon SEO Houston", "Amazon consultant Texas"]
    },
    url: {
      es: "https://luisroc.com/servicios/consultoria-amazon",
      en: "https://luisroc.com/services/amazon-consulting"
    },
    h1: {
      es: "Consultoría Amazon y Marketplaces para Empresas Hispanas",
      en: "Amazon and Marketplaces Consulting for Hispanic Businesses"
    }
  },

  contentConversion: {
    title: {
      es: "Estrategia de Contenido y Conversión Houston | Marketing Content - Luis ROC", 
      en: "Content Strategy & Conversion Houston | Content Marketing - Luis ROC"
    },
    description: {
      es: "Estrategia de contenido SEO, copywriting persuasivo y funnels de conversión para empresas hispanas. Storytelling que convierte, blogs que venden, newsletters que engagement.",
      en: "SEO content strategy, persuasive copywriting and conversion funnels for Hispanic businesses. Storytelling that converts, blogs that sell, newsletters that engage."
    },
    keywords: {
      es: ["estrategia contenido Houston", "copywriting SEO", "funnel conversión", "content marketing empresas hispanas", "storytelling digital", "contenido que convierte", "blog marketing Houston"],
      en: ["content strategy Houston", "SEO copywriting", "conversion funnel", "Hispanic business content marketing", "digital storytelling", "converting content", "blog marketing Houston"]
    },
    url: {
      es: "https://luisroc.com/servicios/contenido-conversion",
      en: "https://luisroc.com/services/content-conversion"
    },
    h1: {
      es: "Estrategia de Contenido que Convierte Visitantes en Clientes",
      en: "Content Strategy that Converts Visitors into Customers"
    }
  },

  rebrandingSeo: {
    title: {
      es: "Rebranding + SEO Houston | Migración Marca EE.UU. - Luis ROC",
      en: "Rebranding + SEO Houston | US Brand Migration - Luis ROC"
    },
    description: {
      es: "Rebranding completo + SEO para empresas latinas migrando a EE.UU. Posicionamiento de marca, identidad digital y optimización web para mercado estadounidense.",
      en: "Complete rebranding + SEO for Hispanic businesses migrating to US. Brand positioning, digital identity and web optimization for American market."
    },
    keywords: {
      es: ["rebranding SEO Houston", "migración marca EE.UU.", "posicionamiento marca hispana", "identidad digital Houston", "rebranding empresas latinas", "SEO rebranding Texas"],
      en: ["rebranding SEO Houston", "US brand migration", "Hispanic brand positioning", "digital identity Houston", "Latino business rebranding", "SEO rebranding Texas"]
    },
    url: {
      es: "https://luisroc.com/servicios/rebranding-seo",
      en: "https://luisroc.com/services/rebranding-seo"
    },
    h1: {
      es: "Rebranding + SEO para Conquistar el Mercado Estadounidense",
      en: "Rebranding + SEO to Conquer the American Market"
    }
  },

  seoSemStrategies: {
    title: {
      es: "Estrategias SEO/SEM Avanzadas Houston | Marketing Digital - Luis ROC",
      en: "Advanced SEO/SEM Strategies Houston | Digital Marketing - Luis ROC"
    },
    description: {
      es: "Estrategias avanzadas SEO y SEM para empresas hispanas en Houston. Combinamos posicionamiento orgánico y publicidad pagada con medición orientada a negocio.",
      en: "Advanced SEO and SEM strategies for Hispanic businesses in Houston. We combine organic positioning and paid advertising with business-oriented measurement."
    },
    keywords: {
      es: ["estrategias SEO SEM Houston", "SEO avanzado empresas hispanas", "SEM marketing digital", "posicionamiento orgánico Houston", "publicidad digital integrada", "SEO SEM Texas"],
      en: ["SEO SEM strategies Houston", "advanced SEO Hispanic businesses", "SEM digital marketing", "organic positioning Houston", "integrated digital advertising", "SEO SEM Texas"]
    },
    url: {
      es: "https://luisroc.com/servicios/estrategias-seo-sem",
      en: "https://luisroc.com/services/seo-sem-strategies"
    },
    h1: {
      es: "Estrategias SEO/SEM que Maximizan tu ROI Digital",
      en: "SEO/SEM Strategies that Maximize your Digital ROI"
    }
  },

  // Herramientas específicas
  aiContentGenerator: {
    title: {
      es: "Generador Contenido IA Gratis | Herramienta SEO - Luis ROC",
      en: "Free AI Content Generator | SEO Tool - Luis ROC"
    },
    description: {
      es: "Generador de contenido con inteligencia artificial gratis. Crea artículos, meta descripciones, títulos SEO y copy persuasivo optimizado para motores de búsqueda.",
      en: "Free artificial intelligence content generator. Create articles, meta descriptions, SEO titles and persuasive copy optimized for search engines."
    },
    keywords: {
      es: ["generador contenido IA", "herramienta SEO gratuita", "IA copywriting", "generador artículos", "contenido automático SEO", "AI content generator español"],
      en: ["AI content generator", "free SEO tool", "AI copywriting", "article generator", "automatic SEO content", "Spanish AI content generator"]
    },
    url: {
      es: "https://luisroc.com/herramientas/generador-contenido-ia",
      en: "https://luisroc.com/tools/ai-content-generator"
    },
    h1: {
      es: "Generador de Contenido con Inteligencia Artificial",
      en: "Artificial Intelligence Content Generator"
    }
  }
};
export const getSEOTemplate = (page: string): SEOTemplate | null => {
  return seoTemplates[page] || null;
};
